<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <router-view @showNotification="notifyVue" @cotentLoading="cotentLoading" >
        </router-view>
      </transition>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      cotentLoading(){
        this.$emit('dashLoading', false)
      },      
      notifyVue (html, color, icon) {
        const notification = {
          template: html
        }
        this.$notify(
          {
            component: notification,
            icon: 'nc-icon '+icon,
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: color
          })
      }, 
    }
  }
</script>
<style lang="scss">
.vue-notifyjs.notifications{
  .alert{
   z-index: 100;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;

  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);

  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
